import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["additionalTracking", "currentTime", "displayInteractiveEducation", "enableQuizMe", "enableSummarize", "enableAdaptToIndustry", "handleDisplayInteractiveEducation", "interactiveEducationEnabled", "onFinish", "children"];
/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/video/components/VideoPlayerWithControls.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */
import { useEffect } from 'react';
import { VideoControls } from './VideoControls.migrated';
import { VideoPlayer, VideoPlayerProvider } from './VideoPlayer.migrated';
import { useCurrentVideoTime } from 'academy-common-lib/features/video/videoTimeStore';
/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/video/components/VideoPlayerWithControls.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export { useCurrentVideoTime };

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/video/components/VideoPlayerWithControls.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/video/components/VideoPlayerWithControls.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const VideoPlayerWithControls = _ref => {
  let {
      additionalTracking,
      currentTime,
      displayInteractiveEducation,
      enableQuizMe,
      enableSummarize,
      enableAdaptToIndustry,
      handleDisplayInteractiveEducation,
      interactiveEducationEnabled = false,
      onFinish,
      children
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    setCurrentVideoTime
  } = useCurrentVideoTime();
  useEffect(() => {
    setCurrentVideoTime(currentTime || 0);
  }, [currentTime, setCurrentVideoTime]);
  return /*#__PURE__*/_jsx(VideoPlayerProvider, {
    children: /*#__PURE__*/_jsxs(VideoPlayer, Object.assign({
      onFinish: onFinish,
      onTimeUpdate: time => setCurrentVideoTime(time)
    }, props, {
      children: [/*#__PURE__*/_jsx(VideoControls, {
        additionalTracking: additionalTracking,
        displayInteractiveEducation: displayInteractiveEducation,
        enableAdaptToIndustry: enableAdaptToIndustry,
        enableQuizMe: enableQuizMe,
        enableSummarize: enableSummarize,
        handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
        interactiveEducationEnabled: interactiveEducationEnabled,
        onFinish: onFinish
      }), children]
    }))
  });
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/video/components/VideoPlayerWithControls.tsx
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export default VideoPlayerWithControls;